import React, { Fragment } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Checkbox } from '@mantine/core';
import {
    Row, Col, Button, Table, Form, Image,
} from 'react-bootstrap';
import { toast } from 'react-toastify';

import { StdModalDialog } from '../blocks/dialog';
import {
    CheckboxField, ControlPageBlock, InputField, TextAreaEditorField,
} from '../blocks/edit_blocks';
import FastImageLoad from '../blocks/fast_image_load';
import Fetcher from '../common/communicate';
import { PROJECT_PREFIX } from '../const';

const centered = { textAlign: 'center' };
const cellWidth = { width: '35%' };
const imgStyles = { height: '94px', width: '100%', objectFit: 'cover' };

export default class QuizTriviaEditScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            current_result: {},

            new_results: [],

            new_question: {
                answers: [],
            },

            new_answer: {},

            data: {
                questions: [],
                results: [],
            },
            not_valid: {},

            questionDialog_open: false,
            resultDialog_open: false,
            editedQuestion: null,

            isVKPQuiz: false,
        };

        this.handleChange = this.handleChange.bind(this);
        this.questionHandleChange = this.questionHandleChange.bind(this);
        this.answerHandleChange = this.answerHandleChange.bind(this);
        this.resultHandleChange = this.resultHandleChange.bind(this);

        this.saveResult = this.saveResult.bind(this);
        this.removeResult = this.removeResult.bind(this);

        this.appendAnswer = this.appendAnswer.bind(this);
        this.removeAnswer = this.removeAnswer.bind(this);

        this.appendQuestion = this.appendQuestion.bind(this);

        this.toggleQuestionDialog = this.toggleQuestionDialog.bind(this);
        this.toggleResultDialog = this.toggleResultDialog.bind(this);

        this.sendData = this.sendData.bind(this);
        this.removeData = this.removeData.bind(this);

        this.editQuestion = this.editQuestion.bind(this);
        this.removeQuestion = this.removeQuestion.bind(this);

        this.handleData = this.handleData.bind(this);

        this.goToNewPage = this.goToNewPage.bind(this);
        this.goToPreviousPage = this.goToPreviousPage.bind(this);

        if (props.match.params.id) {
            this.state.API_ENDPOINT = `quiz_trivia/${props.match.params.id}/`;
        } else {
            this.state.API_ENDPOINT = 'quiz_trivia/';
        }
    }

    goToNewPage(newData) {
        this.setState({ API_ENDPOINT: `quiz_trivia/${newData.id}/` });
        this.props.history.push(`${PROJECT_PREFIX}/quiz_trivia/${newData.id}/edit`);
    }

    goToPreviousPage() {
        this.props.history.push(`${PROJECT_PREFIX}/quiz_trivia/all`);
    }

    removeData() {
        Fetcher(this.state.API_ENDPOINT, 'DELETE', this.goToPreviousPage);
    }

    componentDidMount() {
        if (this.props.match.params.id) {
            Fetcher(this.state.API_ENDPOINT, 'GET', this.handleData);
        }
    }

    handleData(data) {
        this.setState({ loading: false, data });
    }

    toggleQuestionDialog() {
        this.setState({ questionDialog_open: !this.state.questionDialog_open });
    }

    toggleResultDialog() {
        if (this.state.resultDialog_open) { // если окно закрывается, очищаем current_result
            return this.setState({
                resultDialog_open: !this.state.resultDialog_open,
                current_result: {},
            });
        }

        this.setState({
            resultDialog_open: !this.state.resultDialog_open,
        });
    }

    toggleVKPQuiz = () => {
        this.setState({
            isVKPQuiz: !this.state.isVKPQuiz,
        });
    };

    handleChange(event) {
        if (!event) {
            return;
        }

        const state = event.currentTarget.value;
        const new_state = this.state;
        new_state.data[event.currentTarget.id] = state;
        this.setState(new_state);
    }

    resultHandleChange(event) {
        if (!event) {
            return;
        }

        const current_result = {};
        Object.assign(current_result, this.state.current_result);

        if (event.currentTarget.id === 'result_title') {
            current_result.title = event.currentTarget.value;
        }

        if (event.currentTarget.id === 'result_text') {
            current_result.descr = event.currentTarget.value;
        }

        if (event.currentTarget.id === 'result_picture') {
            current_result.image = event.currentTarget.value;
        }

        if (event.currentTarget.id === 'result_score') {
            current_result.score = event.currentTarget.score;
        }

        if (event.currentTarget.id === 'result_score') {
            current_result.score = parseInt(event.currentTarget.value) || 0;
        }

        this.setState({ current_result });
    }

    getCurrentResults(state) {
        if (state.data.results.length === 0) {
            return;
        }

        const html_results_list = [];
        const current_results = state.data.results;

        for (let i = 0; i < current_results.length; i++) {
            html_results_list.push(
                <tr key={`result-${i}`}>
                    <td>{current_results[i].title}</td>
                    <td>{current_results[i].descr}</td>
                    <td>{current_results[i].score}</td>
                    <td><Image src={current_results[i].image} fluid style={imgStyles} /></td>
                    <td>
                        <Button data-resultid={i} onClick={this.editResult} variant="outline-dark" block>
                            <FontAwesomeIcon
                                icon="pencil-alt"
                            />
                        </Button>

                    </td>
                    <td>
                        <Button data-resultid={i} onClick={this.removeResult} variant="outline-danger" block>
                            <FontAwesomeIcon
                                icon="trash"
                            />
                        </Button>

                    </td>
                </tr>,
            );
        }

        return (
            <Table>
                <thead>
                    <tr>
                        <th>Заголовок</th>
                        <th style={{ width: '50%' }}>Текст</th>
                        <th>Мин. правильных</th>
                        <th style={{ width: '20%' }}>Картинка</th>
                        <th />
                    </tr>
                </thead>
                <tbody>
                    {html_results_list}
                </tbody>
            </Table>
        );
    }

    questionHandleChange(event) {
        if (!event) {
            return;
        }

        const current_question = this.state.new_question;

        if (event.currentTarget.id === 'question') {
            current_question.text = event.currentTarget.value;
        }

        if (event.currentTarget.id === 'question_picture') {
            current_question.image = event.currentTarget.value;
        }

        this.setState(current_question);
    }

    answerHandleChange(event) {
        const key = event.currentTarget.id;
        const { value } = event.currentTarget;
        const answerIndex = event.currentTarget.dataset.answer;
        const { new_question } = this.state;

        const newData = {};
        Object.assign(newData, new_question);

        if (event.currentTarget.id === 'is_correct') {
            newData.answers[answerIndex][key] = event.currentTarget.checked;

            return this.setState({
                new_question: newData,
            });
        }

        newData.answers[answerIndex][key] = value;
        this.setState({
            new_question: newData,
        });
    }

    appendAnswer() {
        this.setState({
            new_question: {
                ...this.state.new_question,
                answers: [
                    ...this.state.new_question.answers,
                    {
                        score: 1,
                        text: '',
                    },
                ],
            },
        });
    }

    removeResult(event) {
        const current_data = {};
        Object.assign(current_data, this.state.data);
        const resultId = event.currentTarget.dataset.resultid;

        current_data.results.splice(resultId, 1);
        this.setState({ data: current_data });
    }

    editResult = (event) => {
        const current_data = {};
        Object.assign(current_data, this.state.data);
        const resultId = event.currentTarget.dataset.resultid;
        this.setState({ current_result: current_data.results[resultId] });
        this.toggleResultDialog();
    };

    removeAnswer(event) {
        const current_question = {};
        Object.assign(current_question, this.state.new_question);
        const answerId = event.currentTarget.dataset.answerid;

        current_question.answers.splice(answerId, 1);
        this.setState({ new_question: current_question });
    }

    getCurrentAnswers(state) {
        const current_answers = state.new_question.answers;

        return current_answers.map((answer, i) => (
            <tr key={`answer-${i}`}>
                <td>
                    <Form.Control
                        id="text"
                        onChange={this.answerHandleChange}
                        type="text"
                        placeholder="Вариант ответа"
                        value={answer.text}
                        data-answer={i}
                    />
                    {answer.is_correct && (
                        <Form.Control
                            id="description"
                            onChange={this.answerHandleChange}
                            type="text"
                            as="textarea"
                            placeholder="Описание правильного ответа"
                            value={answer.description}
                            data-answer={i}
                        />
                    )}
                </td>
                <td>
                    <CheckboxField
                        id="is_correct"
                        name="is_correct"
                        value={answer.is_correct}
                        onChange={this.answerHandleChange}
                        dataAnswer={i}
                    />
                </td>
                <td>
                    <Button data-answerid={i} onClick={this.removeAnswer} variant="outline-danger" block>
                        <FontAwesomeIcon icon="trash" />
                    </Button>
                </td>
            </tr>
        ));
    }

    saveResult() {
        const new_data = {};
        const current_result = {};

        if (!this.state.current_result.title) {
            toast.error('Не указан заголовок результата');

            return;
        }

        if (!this.state.current_result.descr) {
            toast.error('Не указано описание результата');

            return;
        }

        if (!this.state.current_result.image) {
            toast.error('Не выбрана картинка результата');

            return;
        }

        Object.assign(new_data, this.state.data);
        Object.assign(current_result, this.state.current_result);

        const editedIndex = new_data.results.findIndex((result) => result.id === current_result.id);

        if (editedIndex >= 0) {
            new_data.results[editedIndex] = current_result;
        } else {
            new_data.results.push(current_result);
        }

        this.setState({ data: new_data, current_result: {} });
        this.toggleResultDialog();
        this.sendData({ currentTarget: 'apply_button' });
    }

    appendQuestion() {
        const { editedQuestion } = this.state;
        const new_data = {};
        const new_question = {};
        Object.assign(new_data, this.state.data);
        Object.assign(new_question, this.state.new_question);

        if (!this.state.new_question.isEdit) {
            new_data.questions.push(new_question);
        }

        new_data.questions[editedQuestion] = this.state.new_question;

        this.setState({
            data: new_data, new_question: { answers: [] }, new_answer: {}, editedQuestion: null,
        });
        this.toggleQuestionDialog();
    }

    editQuestion(event) {
        const current_data = {};
        Object.assign(current_data, this.state.data);
        const questionId = event.currentTarget.dataset.questionid;
        current_data.questions[questionId].isEdit = true;
        this.setState({
            new_question: current_data.questions[questionId],
            editedQuestion: questionId,
        });
        this.toggleQuestionDialog();
    }

    removeQuestion(event) {
        const current_data = {};
        Object.assign(current_data, this.state.data);
        const questionId = event.currentTarget.dataset.questionid;
        current_data.questions.splice(questionId, 1);
        this.setState({ data: current_data });
    }

    getQuestions(state) {
        const html_list = [];

        for (let i = 0; i < state.data.questions.length; i++) {
            const question = state.data.questions[i];
            const answers = [];

            for (let a = 0; a < question.answers.length; a++) {
                answers.push(<tr key={`answ-${a}`}>
                    <td>{question.answers[a].text}</td>
                    <td>{question.answers[a].description}</td>
                    <td style={centered}>{question.answers[a].is_correct ? '✓' : ''}</td>
                </tr>);
            }

            const table = (
                <Row>
                    <Table className="mb-0">
                        <tbody>
                            <tr>
                                <th style={cellWidth}>Текст</th>
                                <th>Описание</th>
                                <th style={centered}>Правильный</th>
                            </tr>
                            {answers}
                        </tbody>
                    </Table>
                </Row>
            );

            html_list.push(
                <Col md={6} style={{ border: '1px solid black', padding: '13px', marginBottom: '2px' }}>
                    <Row>
                        <Col md={12}>
                            <Row>
                                <Col md={6}>
                                    <b>{state.data.questions[i].text}</b>
                                </Col>
                                <Col md={{ span: 2, offset: 2 }}>
                                    <Button data-questionid={i} onClick={this.editQuestion} variant="outline-dark" block>
                                        <FontAwesomeIcon
                                            icon="pencil-alt"
                                        />
                                    </Button>
                                </Col>
                                <Col md={2}>
                                    <Button data-questionid={i} onClick={this.removeQuestion} variant="outline-danger" block>
                                        <FontAwesomeIcon
                                            icon="trash"
                                        />
                                    </Button>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <Image src={state.data.questions[i].image} fluid />
                                </Col>
                            </Row>
                            <Row>
                                <hr />
                            </Row>
                        </Col>
                    </Row>
                    {table}

                </Col>,
            );
        }

        return html_list;
    }

    validate() {
        const no_valid_fields = {};
        const req_fields = ['lead_pic', 'author_info', 'name', 'slug', 'text', 'descr'];

        for (let i = 0; i < Object.keys(req_fields).length; i++) {
            if (!this.state.data[req_fields[i]]) {
                no_valid_fields[req_fields[i]] = true;
            }
        }

        this.setState({ not_valid: Object.assign(this.state.not_valid, no_valid_fields) });
    }

    sendData(event) {
        this.validate();
        let request_method = 'PUT';

        if (!this.props.match.params.id) {
            request_method = 'POST';
        }

        const save_type = event.currentTarget.id;
        let callback = this.handleData;

        if (save_type === 'save_button') {
            callback = this.goToPreviousPage;
        }

        if (!this.props.match.params.id) {
            callback = this.goToNewPage;
        }

        Fetcher(this.state.API_ENDPOINT, request_method, callback, this.state.data);
    }

    render() {
        return (
            <div>
                <Row className="show-grid">
                    <Col md={12}>
                        <h3>
                            Опрос:
                            {' '}
                            {this.state.data.title}
                        </h3>
                    </Col>
                </Row>
                <Row className="show-grid">
                    <Col md={8}>
                        <InputField
                            name="title"
                            label="Название"
                            value={this.state.data.title}
                            onChange={this.handleChange}
                            required
                            maxLength={250}
                            is_not_valid={this.state.not_valid.title || false}
                        />
                    </Col>
                </Row>
                <Row className="show-grid">
                    <Col md={8}>
                        <TextAreaEditorField
                            name="descr"
                            label="Описание"
                            value={this.state.data.descr}
                            onChange={this.handleChange}
                            rows={8}
                            required
                            is_not_valid={this.state.not_valid.descr || false}
                        />
                    </Col>
                    <Col md={4}>
                        <Checkbox
                            mb="xl"
                            label="Викторина VK Play"
                            checked={this.state.isVKPQuiz}
                            onChange={this.toggleVKPQuiz}
                        />
                        <b>Картинка</b>
                        <FastImageLoad
                            key={this.state.isVKPQuiz}
                            name="image"
                            labe="Картинка"
                            image={this.state.data.image}
                            onChange={this.handleChange}
                            minSize={this.state.isVKPQuiz ? '1096x642' : '700x330'}
                        />
                    </Col>
                </Row>

                <Row>
                    <hr />
                </Row>
                <Row>
                    <Col md={8}>
                        <Row className="mb-3">
                            <Col md={7}>
                                <h3>Вопросы и варианты ответов</h3>
                            </Col>
                            <Col md={{ span: 2, offset: 3 }}>
                                <Button onClick={this.toggleQuestionDialog} variant="outline-dark" block>
                                    <FontAwesomeIcon
                                        icon="plus"
                                    />
                                    {' '}
                                    Добавить

                                </Button>
                            </Col>
                        </Row>
                        <Row>
                            {this.getQuestions(this.state)}
                        </Row>

                        <Row>
                            <hr />
                        </Row>

                        <Row className="mb-3">
                            <Col md={7}>
                                <h3>Результаты</h3>
                            </Col>
                            <Col md={{ span: 2, offset: 3 }}>
                                <Button onClick={this.toggleResultDialog} variant="outline-dark" block>
                                    <FontAwesomeIcon
                                        icon="plus"
                                    />
                                    {' '}
                                    Добавить

                                </Button>
                            </Col>
                        </Row>
                        {this.getCurrentResults(this.state)}
                    </Col>
                </Row>

                <ControlPageBlock
                    name={this.state.data.name}
                    onSave={this.sendData}
                    onApply={this.sendData}
                    onCancel={this.goToPreviousPage}
                    onRemove={this.removeData}
                    onReject={false}
                />

                <StdModalDialog
                    isOpen={this.state.questionDialog_open}
                    container={this}
                    hideHandler={this.toggleQuestionDialog}
                    closeHandler={this.toggleQuestionDialog}
                    title="Добавить вопрос"
                    body={(
                        <>
                            <Row>
                                <Col md={6}>
                                    <InputField
                                        name="question"
                                        label="Вопрос"
                                        onChange={this.questionHandleChange}
                                        value={this.state.new_question.text}
                                        maxLength={500}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <hr />
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <FastImageLoad
                                        name="question_picture"
                                        label="Картинка"
                                        image={this.state.new_question.image}
                                        onChange={this.questionHandleChange}
                                        minSize={this.state.isVKPQuiz ? '1096x395' : '700x330'}
                                        altMinSize="440x330"
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <hr />
                            </Row>
                            <Row>
                                <Table>
                                    <thead>
                                        <tr>
                                            <th style={{ width: '60%' }}>Ответ</th>
                                            <th>Правильный</th>
                                            <th />
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.getCurrentAnswers(this.state)}
                                        <tr>
                                            <td />
                                            <td />
                                            <td>
                                                <Button
                                                    onClick={this.appendAnswer}
                                                    variant="outline-dark"
                                                    block
                                                >
                                                    <FontAwesomeIcon icon="plus" />
                                                </Button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </Row>

                            <Row>
                                <hr />
                            </Row>

                        </>
                    )}
                    onSave={this.appendQuestion}
                />

                <StdModalDialog
                    isOpen={this.state.resultDialog_open}
                    container={this}
                    hideHandler={this.toggleResultDialog}
                    closeHandler={this.toggleResultDialog}
                    title="Добавить результат"
                    body={(
                        <>
                            <Row>
                                <Col md={12}>
                                    <InputField
                                        name="result_title"
                                        label="Описание"
                                        value={this.state.current_result.title}
                                        onChange={this.resultHandleChange}
                                        rows={8}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <TextAreaEditorField
                                        name="result_text"
                                        label="Описание"
                                        value={this.state.current_result.descr}
                                        onChange={this.resultHandleChange}
                                        rows={8}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <FastImageLoad
                                        name="result_picture"
                                        label="Картинка"
                                        image={this.state.current_result.image}
                                        onChange={this.resultHandleChange}
                                        minSize={this.state.isVKPQuiz ? '1096x395' : '700x330'}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <Form.Label>Минимум правильных ответов</Form.Label>
                                    <Form.Control
                                        id="result_score"
                                        type="number"
                                        placeholder="0"
                                        onChange={this.resultHandleChange}
                                        value={this.state.current_result.score}
                                    />
                                </Col>
                            </Row>
                        </>
                    )}
                    onSave={this.saveResult}
                />
            </div>

        );
    }
}
